import React from 'react';
import { Link } from 'react-router-dom';
import SignedInLinks from './SignedInLinks';
import SignedOutLinks from './SignedOutLinks';
import { connect } from 'react-redux';
import logo from '../../logo_white.png';

import * as ROUTES from '../../constants/routes';

const Navbar = (props) => {
    const { auth, profile } = props;

    const links = auth.uid ? <SignedInLinks profile={profile} auth={auth}/> : <SignedOutLinks />;


    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark mb-3" >
            <div className="container navbar-custom">
                <Link to={ROUTES.HOME} className="logo pull-left navbar-brand">
                    <img src={logo} alt="Logo" style={{ height: "30px" }}></img>
                </Link>
                <button 
                    className="navbar-toggler" 
                    type="button" 
                    data-toggle="collapse" 
                    data-target="#navbarResponsive" 
                    aria-controls="navbarResponsive" 
                    aria-expanded="false" 
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive" style={{ marginTop: "5px" }}>
                    {auth.isLoaded && links}
                </div>
            </div>
        </nav>
    )
};

const mapStateToProps = (state) => {
    // console.log("STATE: " + state);
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile
    }
}

export default connect(mapStateToProps)(Navbar);